import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Sign-in Method")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email Address", -1)
const _hoisted_7 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_8 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Password must be at least 8 character and contain symbols ", -1)
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4" }
const _hoisted_15 = { class: "fv-row mb-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Current Password", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "fv-row mb-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "New Password", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-lg-4" }
const _hoisted_25 = { class: "fv-row mb-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm New Password", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update Password ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            id: "kt_signin_email",
            class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.user.email), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            id: "kt_signin_password",
            class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
          }, _hoisted_11, 2),
          _createElementVNode("div", {
            id: "kt_signin_password_edit",
            class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
          }, [
            _hoisted_12,
            _createVNode(_component_Form, {
              id: "kt_signin_change_password",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePassword())),
              "validation-schema": _ctx.changePassword
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                        modelValue: _ctx.UserForm.old_password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.UserForm.old_password) = $event)),
                        name: "currentpassword",
                        id: "currentpassword"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                        name: "newpassword",
                        modelValue: _ctx.UserForm.new_password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.UserForm.new_password) = $event)),
                        id: "newpassword"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_ErrorMessage, { name: "newpassword" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                        name: "confirmpassword",
                        id: "confirmpassword"
                      }),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", _hoisted_30, _hoisted_33, 512),
                  _createElementVNode("button", {
                    id: "kt_password_cancel",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                    class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                  }, " Cancel ")
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"])
          ], 2),
          _createElementVNode("div", {
            id: "kt_signin_password_button",
            class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
          }, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
              class: "btn btn-light fw-boldest"
            }, " Ganti Password ")
          ], 2)
        ])
      ])
    ])
  ]))
}